import { createContext } from "../../utils/createContext";

import type { UseModalReturn } from "./useModal";

export const [ModalProvider, useModalContext] = createContext<UseModalReturn>({
  name: "ModalContext",
});
